import React from 'react'
import Button from 'blocks.simple/button/button'
import translate from 'core/translate'
import helpers from 'core/helpers'
import { changeFilter } from 'features/routes'
import moment from 'moment'
import { INotificationFilterFields } from '../NotificationСenterHooks'
import styles from './notificationFilterList.jcss'

interface IFilterItem {
    field: keyof INotificationFilterFields
    value: string
    label: string
}

interface INotificationFilterListProps {
    filters: INotificationFilterFields
}

const optionLabels: Record<string, string> = {
    read: 'read',
    unread: 'notRead',
    information: 'information',
    warning: 'warning',
    error: 'error',
    default: 'information',
    license: 'licensing',
    digitalSignage: 'digitalSignage_permissions',
    engineeringWorks: 'engineeringWorks',
    broadcast: 'broadcasts',
    content: 'content',
}

const getFilterItems = (filters: INotificationFilterFields): IFilterItem[] => {
    const items: IFilterItem[] = []

    ;(['status', 'type', 'category'] as const).forEach((field) => {
        filters[field].forEach((value) => {
            items.push({
                field,
                value,
                label: translate(optionLabels[value] || value),
            })
        })
    })

    if (filters.startDate) {
        items.push({
            field: 'startDate',
            value: filters.startDate,
            label: `${translate('startDate')}: ${moment(filters.startDate).format('DD.MM.YYYY')}`,
        })
    }
    if (filters.endDate) {
        items.push({
            field: 'endDate',
            value: filters.endDate,
            label: `${translate('endDate')}: ${moment(filters.endDate).format('DD.MM.YYYY')}`,
        })
    }

    return items
}

export const NotificationFilterList = ({ filters }: INotificationFilterListProps) => {
    const filterItems = getFilterItems(filters)

    const removeFilterItem = (item: IFilterItem) => {
        const queryKey = helpers.prefixQuery({ name: 'notificationCenter', field: item.field })
        const values = filters[item.field]
        const nextValue = Array.isArray(values) ? values.filter((value) => value !== item.value).join('//') : ''

        changeFilter({ [queryKey]: nextValue }, false)
    }

    if (!filterItems.length) return null

    return (
        <div className={styles.filterOptions} aria-label={translate('filter')}>
            {filterItems.map((item) => (
                <div className={styles.filterItem} key={`${item.field}_${item.value}`}>
                    <Button
                        icon="close"
                        textSize="mini"
                        indentSize="mini"
                        animation={false}
                        iconSize={10}
                        onIconClick={() => removeFilterItem(item)}
                    >
                        {item.label}
                    </Button>
                </div>
            ))}
        </div>
    )
}
